/**
 * Quick fixes
 *
 * Deadlines happen, so put your quick fixes here. Hopefully there will be time
 * later to move/re-factor these styles into their proper place.
 */

// Module template
import './_layout.scss';
import './_block.scss';
import './_case-study.scss';
import './_content-box-tags.scss';
import './_form.scss';
import './_user-forms.scss';
import './_company-profile.scss';
import './_consultant-profile.scss';
import './_event.scss';
import './_project.scss';
import './_explanation-graphic.scss';
import './_medium-project-page.scss';
import './_on-page-nav.scss';
import './_reativesearch.scss';
import './_rs-modal.scss';
import './_sidebar.scss';
import './_temporary.scss';
import './_user-dashboard.scss';
